/** Textes « reservation » — le français fait foi. */
export const reservation = {
  datesSignale: 'Changement de dates signalé — un gérant le validera dans « À valider ».',
  signalementEchec: "Le signalement n'a pas abouti.",
  cautionTraitee: 'Caution traitée — la décharge de restitution est prête à imprimer.',
  restitutionEchec: "La restitution n'a pas abouti.",
  contratGenere: 'Contrat genere — vous pouvez l\'imprimer et enregistrer la caution.',
  cautionEnregistree: (n: string) => `Caution enregistree — decharge ${n} prete a imprimer.`,
  annulee: 'Location annulée — le motif est au journal.',
  annulationImpossible: 'Annulation impossible',
  prolongee: (j: number, m: string) => `Location prolongée de ${j} jour(s) — nouveau total ${m}.`,
  prolongationImpossible: 'Prolongation impossible',
  resilie: (saisie: boolean) => `Contrat résilié${saisie ? ' — caution saisie (article 07)' : ''}. Le motif est au journal.`,
  resiliationImpossible: 'Résiliation impossible',
  demandeEnvoyee: 'Demande envoyée — les gérants ont été prévenus.',
  genererContrat: 'Générer le contrat',
  imprimerContrat: 'Imprimer le contrat',
  enregistrerCaution: 'Enregistrer la caution',
  signalerDates: 'Signaler un changement de dates',
  restituerCaution: (m: string) => `Restituer la caution · ${m}`,
  encaisserSolde: (m: string) => `Encaisser le solde · ${m}`,
  faireDepart: 'Faire le départ',
  faireRetour: 'Faire le retour',
  corrigerRetour: 'Corriger le retour (heure, km, carburant)',
  prolongerLocation: 'Prolonger la location',
  annulerLocation: 'Annuler la location',
  resilierContrat: 'Résilier le contrat',
  cautionNonEnregistree: "La caution n'a pas été enregistrée",
  cautionNonEnregistreeTexte: 'La location est bien créée et numérotée — ne la ressaisissez pas. Il ne reste que la caution à prendre : établissez le contrat, puis enregistrez-la. Le montant convenu est déjà pré-rempli.',
  listeNoire: 'Client en liste noire',
  derogation: (d: string) => `Derogation article 01 — ${d}`,
  derogationDetail: (motif: string, date: string) => `Motif : ${motif} · accordée le ${date}`,
  documents: 'Documents à imprimer',
  contratLocation: 'Contrat de location',
  contratDetail: (n: string) => `n° ${n} · bilingue, avec l'état des lieux`,
  imprimer: 'Imprimer',
  dechargeRemise: 'Décharge de caution — remise',
  dechargeRemiseDetail: (n: string, m: string) => `n° ${n} · ${m} reçus`,
  dechargeRestitution: 'Décharge de caution — restitution',
  numero: (n: string) => `n° ${n} · `,
  facture: (type: string) => `Facture ${type === 'avoir' ? "d'avoir" : type === 'acompte' ? "d'acompte" : 'de solde'}`,
  factureDetail: (n: string, d: string, m: string) => `n° ${n} · ${d} · ${m}`,
  dechargeApparaitra: "La décharge apparaîtra ici dès que la caution sera enregistrée, et les factures dès qu'elles seront émises.",
  location: 'Location',
  prixMois: 'Prix du mois',
  nMois: (n: number | undefined) => `${n} mois `,
  nJours: (n: number) => `(${n} jours)`,
  tarifReference: 'Tarif de référence',
  parJour: (m: string) => `${m} / jour`,
  prixNegocie: 'Prix négocié',
  joursSaison: (n: number, saison: string) => `${n} jour(s) · saison ${saison}`,
  saisons: { haute: 'haute', basse: 'basse' } as Record<string, string>,
  kilometrage: 'Kilométrage',
  illimite: 'illimité',
  forfaitJour: (n: number | undefined, u: string) => `${n} ${u} / jour`,
  paiement: 'Paiement',
  differe: 'différé — à crédit',
  parTranches: 'par tranches',
  surPlace: 'sur place',
  totalHt: 'Total hors taxes',
  tva: (pct: number | undefined) => `TVA ${pct} %`,
  totalPrevu: (ttc: boolean) => `Total prévu${ttc ? ' TTC' : ''}`,
  contratCaution: 'Contrat et caution',
  aucunContrat: 'Aucun contrat encore généré. Il sera créé au moment du départ.',
  numeroLabel: 'Numéro',
  edlDepart: 'État des lieux départ',
  edlRetour: 'État des lieux retour',
  encaisse: 'Encaissé',
  soldeDu: 'Solde dû',
  caution: 'Caution',
  supplementsRetour: 'Suppléments facturés au retour',
  colSupplement: 'Supplément', colCalcul: 'Calcul', colMontant: 'Montant',
  modifieManuellement: 'modifié manuellement',
  etatDesLieux: 'État des lieux',
  depart: 'Départ',
  retour: 'Retour',
  pasEncore: 'Pas encore saisi.',
  date: 'Date',
  carburant: 'Carburant',
  proprete: 'Propreté',
  propreteValeur: (pi: number, pe: number) => `${pi}/10 int. · ${pe}/10 ext.`,
  dommages: 'Dommages',
  dontNouveaux: (n: number) => ` (dont ${n} nouveau(x))`,
  photos: 'Photos',
  ouvrirGrand: 'Ouvrir en grand',
  saisieDefinitive: 'Votre saisie est définitive',
  saisieDefinitiveTexte: 'Vous ne pouvez pas modifier ce dossier. Si quelque chose est faux, demandez une correction : un gérant la traite, et les deux valeurs restent au journal.',
  demanderCorrection: 'Demander une correction',
  voirPlanning: 'Voir dans le planning',
  actuellement: (a: string, b: string) => `Actuellement du ${a} au ${b}`,
  rienModifie: "Vous ne modifiez rien : la demande part dans « À valider ». Dès qu'un gérant l'accorde, les dates changent et le total du contrat suit.",
  nouveauDepart: 'Nouveau départ',
  nouveauRetour: 'Nouveau retour',
  laissezVide: 'Laissez vide si la date ne change pas.',
  cePasse: "Ce qui s'est passé (obligatoire)",
  cePassePlaceholder: 'Le client rend la voiture deux jours plus tard, prévenu par téléphone.',
  annuler: 'Annuler',
  envoyerAValider: 'Envoyer à « À valider »',
  restituerTitre: (n: string) => `Restituer la caution ${n}`,
  detenus: (m: string) => `${m} détenus`,
  appartientClient: 'Cet argent appartient au client. Ce que vous retenez doit être justifié par écrit.',
  montantRetenu: 'Montant retenu',
  montantRetenuAide: 'Laissez 0 pour restituer la totalité.',
  motifRetenue: 'Motif de la retenue (obligatoire)',
  motifRetenuePlaceholder: 'Dommage constaté au retour, carburant manquant…',
  aRestituer: 'À restituer',
  sigClient: 'Signature du client',
  sigDirecteur: 'Signature du directeur',
  restituerEditer: 'Restituer et éditer la décharge',
  cautionPasFixe: "La caution n'est pas un montant fixe : vous la décidez pour cette location. Une décharge numérotée et signée sera générée immédiatement.",
  montant: 'Montant',
  devise: 'Devise',
  forme: 'Forme',
  formes: { especes: 'Espèces', cheque: 'Chèque', traite: 'Traite', carte: 'Carte bancaire' },
  numeroPiece: 'N° de pièce',
  numeroPieceAide: 'Numéro du chèque ou de la traite.',
  enregistrerEditer: 'Enregistrer et éditer la décharge',
  retourPrevuA: "Retour prévu aujourd'hui : ",
  retourPrevuB: (j: number) => ` — ${j} jour(s),`,
  moisRecalcule: 'Cette location est au mois : le total se recalcule en mois entiers.',
  doitEtreApres: 'Doit être après le retour actuel. Pour raccourcir, passez par un gérant.',
  apercuMois: 'le total se recalcule en mois entiers',
  apercuJours: (j: number, m: string) => `+${j} jour(s) · environ ${m} au total`,
  motif: 'Motif',
  motifAide: 'Facultatif, mais il reste au journal.',
  motifProlongationPlaceholder: "Le client garde la voiture jusqu'à samedi",
  doitEtreLibre: 'La voiture doit être libre sur les jours ajoutés',
  dejaPromise: "Si elle est déjà promise à quelqu'un d'autre, le logiciel refuse et vous dit à quelle date elle se libère.",
  revenir: 'Revenir',
  prolonger: 'Prolonger',
  annulerTitre: 'Annuler cette location',
  motifDefinitif: 'Le motif est obligatoire et définitif',
  resteJournal: 'Il restera au journal avec votre nom. La location ne pourra pas être rétablie.',
  dejaCommence: 'Cette location a déjà commencé',
  voitureSortie: "La voiture est sortie : l'état des lieux de départ est enregistré. ",
  dejaEncaisses: (m: string) => `${m} ont déjà été encaissés — l'annulation ne les rend pas et ne les sort pas de la caisse. `,
  plutotResilierA: 'Si le client a manqué à ses obligations, utilisez plutôt ',
  plutotResilierB: '« Résilier le contrat »',
  plutotResilierC: " : l'article 07 prévoit alors la caution.",
  motifAnnulation: "Motif de l'annulation",
  motifAnnulationPlaceholder: "Client s'est désisté, voiture immobilisée…",
  resiliationManquement: 'Résiliation pour manquement',
  article07: "Votre article 07 prévoit la perte de la caution en cas d'usage interdit — transport de voyageurs, conduite par un tiers, marchandises. Le motif restera au journal.",
  motifResiliation: 'Motif de la résiliation',
  motifResiliationPlaceholder: 'Véhicule utilisé pour du transport de voyageurs (article 07)',
  saisirCaution: "Saisir la caution au titre de l'article 07",
  resilier: 'Résilier',
  queCorriger: 'Que faut-il corriger ?',
  queCorrigerPlaceholder: 'km au départ, date de retour…',
  valeurEnregistree: 'Valeur enregistrée',
  valeurEnregistreeAide: "Ce qui est écrit aujourd'hui.",
  valeurCorrecte: 'Valeur correcte',
  valeurCorrecteAide: "Ce qu'il faut mettre à la place.",
  pourquoi: 'Pourquoi ?',
  pourquoiPlaceholder: 'Inversion de chiffres à la saisie',
  correctionFinanciere: 'Correction financière',
  toucheArgent: "Elle touche à l'argent : seul le gérant · finances pourra la trancher.",
  envoyerDemande: 'Envoyer la demande',
};
